import { validateUrl } from 'components/RichTextEditor/urlValidation'
import { createSelector } from 'reselect'
import { initialEditorInstance } from './initialState'
import { RichTextEditorState } from './types'

type RootState = { richTextEditor: RichTextEditorState }

const selectEditorInstance = (state: RootState, editorId: string) =>
  state.richTextEditor.editors[editorId] || initialEditorInstance

export const selectLinkBubble = createSelector(
  [selectEditorInstance],
  editor => editor.linkBubble
)

export const selectLinkInputValue = createSelector(
  [selectEditorInstance],
  editor => editor.linkInputValue
)

export const selectIsLinkInvalid = createSelector(
  [selectLinkInputValue],
  inputValue => inputValue.trim() !== '' && !validateUrl(inputValue).valid
)
